import { render, staticRenderFns } from "./JobProfileCard.vue?vue&type=template&id=1be33cf9&scoped=true&"
import script from "./JobProfileCard.vue?vue&type=script&lang=js&"
export * from "./JobProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./JobProfileCard.vue?vue&type=style&index=0&id=1be33cf9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be33cf9",
  null
  
)

export default component.exports